import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 8EA26066-2C66-4A38-996B-8F23E288E0B7
 * name elevator-up
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/elevator-up.svg
 * tags
 * - Transportation + Other 
 */
export const ElevatorUpIcon = createSvgIcon(<><path d="M7 2L11 6H8V10H6V6H3L7 2M17 2L13 6H16V10H18V6H21L17 2M7 12H17C18.11 12 19 12.9 19 14V20C19 21.11 18.11 22 17 22H7C5.9 22 5 21.11 5 20V14C5 12.9 5.9 12 7 12M7 14V20H17V14H7Z" /></>, 'ElevatorUpIcon');
export default ElevatorUpIcon